//add useState for handling the image as a file and then the image as a url from firebase
import React, {useState} from 'react'
import {storage} from "../../firebase/firebase"
import { Card, Container, Button,  Accordion, Row, Col } from 'react-bootstrap';
import cardCss from './FirebaseFileUpload.css';
import axios from '../../axios-orders';
import { Router, Route, Switch, withRouter, useHistory, useParams, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import firebase from "firebase/app";
import "firebase/auth";
import Spinner from '../../components/UI/Spinner/Spinner';

import 'bootstrap/dist/css/bootstrap.min.css';

//add import for storage 
const firebaseFileUpload = (props) => {
    const history = useHistory();

    const allInputs = {imgUrl: ''}
    const [imageAsFile, setImageAsFile] = useState('')
    const [imageAsUrl, setImageAsUrl] = useState(allInputs)
    const [isUploading, setUploading] = useState(false)
    const [agegroup, setAgegroup] = useState('adult')
    const [bookType, setBookType] = useState('pdf')
    console.log(imageAsFile)
    const handleImageAsFile = (e) => {
         const image = e.target.files[0]
         setImageAsFile(imageFile => (image))
    }

    const cancelHandler = (event) => {
      event.preventDefault();
      history.push('/pdfTable');
    }

    const handleAgeChange = (event) => {
      setAgegroup(event.target.value)    
    }
  
    const handleBookTypeChange = (event) => {
      setBookType(event.target.value)    
    }

    const handleFireBaseUpload = e => {
        e.preventDefault()
        var pdftitle = document.getElementById('title').value;
        var author = document.getElementById('author').value;
        var tags = document.getElementById('tags').value;
        var pgCnt = document.getElementById('pgCnt').value;
        var language = document.getElementById('language').value;
        var booktype = bookType;
        var age = agegroup;
        const userEmail = props.userEmail;

        
        setUploading(true);
      console.log('start of upload')
      const metadata = {'auth':props.token}
      // async magic goes here...
      if(imageAsFile === '') {
        console.error(`not an image, the image file is a ${typeof(imageAsFile)}`)
      }
      const uploadTask = storage.ref(`/pdf/${imageAsFile.name}`).put(imageAsFile)
      //initiates the firebase side uploading 
      uploadTask.on('state_changed', 
      (snapShot) => {
        //takes a snap shot of the process as it is happening
        console.log(snapShot)
      }, (err) => {
        //catches the errors
        console.log(err)
      }, () => {
        // gets the functions from storage refences the image storage in firebase by the children
        // gets the download url then sets the image from firebase as the value for the imgUrl key:
        storage.ref('pdf').child(imageAsFile.name).getDownloadURL()
         .then(fireBaseUrl => {
           setImageAsUrl(prevObject => ({...prevObject, imgUrl: fireBaseUrl}))
           //alert("title:"+pdftitle+":author:"+author+":pgCnt:"+pgCnt+":tags:"+tags+":url:"+fireBaseUrl+":age:"+JSON.stringify(age));

           const pdfMetadata = {
            title: pdftitle,
            author: author,
            language: language,
            tags: tags,
            pgCnt: pgCnt,
            age: age,
            uploader: userEmail,
            booktype: booktype,
            url: fireBaseUrl
          };

           axios.post( '/pdfMetadata.json?auth='+props.token, pdfMetadata )
           .then( response => {
                alert("Your PDF was successfully uploaded.")
                history.push("/PdfTable");
           } )
           .catch( error => {
               alert( "error:"+error ) ;
           } );





         })
      })
      }

      

    let divContent = () => { 
      if(!isUploading){
        return  (<Card className={cardCss.aliCard}>
          <Card.Header style={{fontWeight:'bold', fontSize:'1.2em', textAlign:"left", color:"white", backgroundColor:"#042a4a"}}>
            Upload a PDF file
          </Card.Header>
          <Card.Body>
            <form onSubmit={handleFireBaseUpload}>

            <div className="row" style={{marginTop:'20px'}}>
                <div className="col-sm-6" style={{textAlign:'left'}}><b>Title</b><br></br><input type="text" id="title"></input></div>
            </div>

            <div className="row" style={{marginTop:'20px'}}>
                <div className="col-sm-6" style={{textAlign:'left'}}><b>Author</b><br></br><input type="text" id="author"></input></div>
            </div>

            <div className="row" style={{marginTop:'20px'}}>
                <div className="col-sm-6" style={{textAlign:'left'}}><b>Language</b><br></br><input type="text" id="language"></input></div>
            </div>

            <div className="row" style={{marginTop:'20px'}}>
                <div className="col-sm-6" style={{textAlign:'left'}}><b>Age Group</b><br></br>
                  <input type="radio" value="adults" name="age" onChange={handleAgeChange} checked='true'/> Adults 
                  <input type="radio" value="kids" name="age" onChange={handleAgeChange} /> Kids
                </div>
            </div>

            <div className="row" style={{marginTop:'20px'}}>
                <div className="col-sm-6" style={{textAlign:'left'}}><b>Book Type</b><br></br>
                  <input type="radio" value="pdf" name="btype" onChange={handleBookTypeChange} checked='true'/> PDF 
                  <input type="radio" value="audio" name="btype" onChange={handleBookTypeChange} /> Audio
                </div>
            </div>

            <div className="row" style={{marginTop:'20px'}}>
                <div className="col-sm-6" style={{textAlign:'left'}}><b>Page Count / Minutes</b><br></br><input type="text" id="pgCnt"></input></div>
            </div>

            <div className="row" style={{marginTop:'20px'}}>
                <div className="col-sm-6" style={{textAlign:'left'}}><b>Tags</b><br></br><textarea className={cardCss.tagtextarea} id="tags"></textarea></div>
            </div>


            <div className="row" style={{marginTop:'20px'}}>
                <div className="col-sm-6" style={{textAlign:'left'}}>
                <b>File</b><br></br>
                    <input 
                    type="file"
                    onChange={handleImageAsFile}
                    />
                </div>
            </div>

            <div className="row" style={{marginTop:'40px'}}>
                <div className="col-sm-6" style={{textAlign:'center'}}>
                    <button className="btn btn-secondary px-4" style={{fontSize:"15px"}}>Upload File</button>
                    &nbsp;&nbsp;<button className="btn btn-warning px-8" style={{fontSize:"15px"}} onClick={cancelHandler.bind()}>Cancel</button>
                </div>
            </div>
            </form>
        </Card.Body>
      </Card>);
      }
      else
      {
        return  (<div><Spinner /></div>);
      }
  };

    return (
        <div className={cardCss.mainDiv}>
          {divContent()}
        </div>
  );
}

const mapStateToProps = state => {
    return {
      isAuthenticated: state.auth.token !== null,
      token: state.auth.token,
      userEmail: state.auth.userEmail,
    };
  };
  
export default withRouter(
    connect(
      mapStateToProps,
    )(firebaseFileUpload)
);
  



// WEBPACK FOOTER //
// ./src/containers/FirebaseFileUpload/FirebaseFileUpload.js